import {
  ALL_INVENTORY_PRODUCTS,
  LOW_INVENTORY_PRODUCTS,
  OUT_OF_STOCK_INVENTORY,
  INVENTORY_IS_FETCHING,
  INVENTORY_IS_FETCHED,
  INVENTORY_ERROR_FETCHING,
  CHANGE_INVENTORY_TABS,
  SHOW_PRODUCT_INVENTORY_VIEW,
  HIDE_PRODUCT_INVENTORY_VIEW
} from '../actions/types';

const DataObject = {
  is_Fetching: false,
  data: null,
  error: null
}

const initialState = {
  currentTab: 'ALL_PRODUCTS',
  viewinventorybatch: {
    showDiag: false,
    data: null
  },
  allProducts: DataObject,
  lowInventory: DataObject,
  outOfStock: DataObject
}

function getReducerData(action, state, data) {
  switch (action) {
    case INVENTORY_IS_FETCHING:
      return {
        ...state,
        is_Fetching: true,
      }

    case INVENTORY_IS_FETCHED:
      return {
        ...state,
        is_Fetching: false,
        error: null,
        data
      }

    case INVENTORY_ERROR_FETCHING:
      return {
        ...state,
        is_Fetching: false,
        error: data
      }

    default:
      return state;
  }
}

export function productInventoryReducer(state = initialState, action) {
  const { type, actionType, payload } = action;
  const { allProducts, lowInventory, outOfStock, viewinventorybatch } = state;

  switch (type) {
    case ALL_INVENTORY_PRODUCTS:
      return {
        ...state,
        allProducts: getReducerData(actionType, allProducts, payload)
      };

    case LOW_INVENTORY_PRODUCTS:
      return {
        ...state,
        lowInventory: getReducerData(actionType, lowInventory, payload)
      };

    case OUT_OF_STOCK_INVENTORY:
      return {
        ...state,
        outOfStock: getReducerData(actionType, outOfStock, payload)
      };

    case CHANGE_INVENTORY_TABS:
      return {
        ...state,
        currentTab: payload
      }

    case SHOW_PRODUCT_INVENTORY_VIEW:
      return {
        ...state,
        viewinventorybatch: {
          data: payload,
          showDiag: true
        }
      }

    case HIDE_PRODUCT_INVENTORY_VIEW:
      return {
        ...state,
        viewinventorybatch: {
          data: null,
          showDiag: false
        }
      }

    default:
      return state;
  }
}